/**
 * Localized slug mapping for /products/spot-welding/:machineId.
 * EN machineId (canonical, used in machineData and as React Router param) ↔ SL slug.
 *
 * Add entries here whenever a machine needs a Slovenian URL slug that
 * differs from the EN one. Routes without a mapping fall back to using
 * the same slug in both languages.
 */

export const SPOT_WELDING_EN_TO_SL: Record<string, string> = {
  "hand-held-welding-gun": "rocni-varilni-tockalnik",
  "fast-spotter": "aparat-za-varjenje-navojnih-cepov",
};

export const SPOT_WELDING_SL_TO_EN: Record<string, string> =
  Object.fromEntries(Object.entries(SPOT_WELDING_EN_TO_SL).map(([en, sl]) => [sl, en]));

/** Return the slug to use for a given language. */
export function spotWeldingSlug(enMachineId: string, lang: "en" | "sl"): string {
  if (lang === "sl") return SPOT_WELDING_EN_TO_SL[enMachineId] ?? enMachineId;
  return enMachineId;
}

/** Resolve any slug (EN or SL) back to the canonical EN machineId. */
export function resolveSpotWeldingId(slug: string): string {
  return SPOT_WELDING_SL_TO_EN[slug] ?? slug;
}
